<h1>Audits components {{ applicationName }}</h1>
<mic-table class="table-stripped" #paginatedTable [fetcher]="fetcher" [config]="auditsTableConfig" [filtersConfig]="filtersConfig">
  <ng-container *micCellTemplate="let item; name: 'Data'">
    <a (click)="fileLink(item)" class="file_download"><mic-icon icon="file_download"></mic-icon></a>
  </ng-container>
  <ng-container *micTableNoData>
    <mic-empty-state icon="layers_clear" title="There is no element to display."> </mic-empty-state>
  </ng-container>
</mic-table>
